<app-topnav [llttfPage]="llttfPage"></app-topnav>

<div class="container">
  <div class="content" role="main">
    <div class="cmha-dashboard">
      <div class="participant-banner" [ngClass]="participantClassByRole">
        <div class="container">
          <h2>{{'viewPlanText'|translate:translations}}</h2>
        </div>
      </div>
      <div class="h-30"></div>
      <div class="container">
        <div class="plan-goals-heading closed-plan-header">
          <span><img src="assets/plan-goals.svg" class="plan-goal-thumbnail"></span>
          <span class="w-10p"></span>
          <div class="closed-plan-header-content-div">
            <h2>{{closedPlanView.planName}}</h2>
            <span class="plan-date-and-reminder-div">
            <span><img src="assets/calendar.svg" class="reminder-bell pr-3">{{ getScheduleLabel(closedPlanView.whenAreYouGoingToDoIt) }}</span>
            <span class="w-20p"></span>
            <span><img src="assets/reminder-bell.svg" class="reminder-bell pr-3"> {{ getScheduleLabel(closedPlanView.reminderFrequency) }}</span>
          </span>
        </div>
        </div>
        <div class="h-30"></div>
        <div class="closed-plan-form">
          <span class="question">{{'whatAreYouGoingToDoText'|translate:translations}}?</span>
          <span class="answer">{{closedPlanView.whatAreYouGoingToDo}}</span>
          <div class="mb-10"></div>
          </div>

          <div class="closed-plan-form">
          <span class="question"> {{'problemsText'|translate:translations}}?</span>
          <span class="answer">{{closedPlanView.difficultiesAndSolutions}}</span>
          <div class="mb-10"></div>
          </div>

          <div class="closed-plan-form">
          <span class="question"> {{'finalPlanText'|translate:translations}}</span>
          <span class="answer">{{closedPlanView.finalPlan}}</span>
          <div class="mb-10"></div>
          </div>

          <div class="closed-plan-form">
          <span class="question"> {{'didYouTryToDoItText'|translate:translations}}?</span>
          <span class="answer">{{closedPlanView.didYouTryToDoIt?'Yes':'No'}}</span>
          <div class="mb-10"></div>
          </div>

        <div [hidden]="!closedPlanView.didYouTryToDoIt">
          <div class="closed-plan-form" >
          <span class="question" > {{'wentWellText'|translate:translations}}?</span>
          <span class="answer">{{closedPlanView.wentWellAndNotSoWell}}</span>
          <div class="mb-10"></div>
          </div>

          <div class="closed-plan-form">
          <span class="question">{{'learnedFromWhatHappenedText'|translate:translations}}?</span>
          <span class="answer">{{closedPlanView.learnedFromWhatHappened}}</span>
          <div class="mb-10"></div>
          </div>
        </div>

        <div [hidden]="closedPlanView.didYouTryToDoIt">
          <span style="margin-left: 15%;"> {{'stoppedYouText'|translate:translations}}?</span>
          <div class="closed-plan-form" >
          <span class="question">I {{'internalThingsText'|translate:translations}}</span>
          <span class="answer">{{closedPlanView.whatStoppedYouInternalThings}}
          </span>
          <div class="mb-10"></div>
          </div>

          <div class="closed-plan-form">
          <span class="question"> {{'externalThingsText'|translate:translations}}</span>
          <span class="answer">{{closedPlanView.whatStoppedYouExternalThings}}</span>
          <div class="mb-10"></div>
          </div>

          <div class="closed-plan-form">
          <span class="question"> {{'plannedText'|translate:translations}}?</span>
          <span class="answer">{{closedPlanView.plannedToDealWithTheseThings}}</span>
          <div class="mb-10"></div>
          </div>
        </div>
      </div>
  </div>
</div>
</div>

<app-footer [bbapp]="true"></app-footer>
